import React from 'react';
import { Container, ReadTime, Content, Tag } from './Body.style';
import Quote from './Quote';
import Heading from '../../common/Heading/Heading';
import { getWordsPerMin } from 'components/utils/helper';
import { Link } from 'react-router-dom';

const Body = ({cms, content, quote, quotePosition, wordCount, tags}) => {

    function renderContent() {
        let result = [];
        /* This contentCount is needed to show quote in the right position
        ** ol/ul items are combined in a paragrahp sometimes. */
        let contentCount = 0;
         // eslint-disable-next-line
        content.map((paragraph, i) => {
            // Content
            let tag;
            switch(paragraph.style){
                case 'h1':
                    tag = {name: 'Heading', level: 'h4'};
                    break;
                case 'ul':
                case 'ol':
                    tag = {name: paragraph.style};
                    break;
                default:
                    tag = {name: 'p'};
                    break;
            }   

            // If the data element isn't an array, make it one
            if (!Array.isArray(paragraph.data)) {
                paragraph.data = [paragraph.data];
            }

            // In case of rendering ordered list (ol) or unordered list (ul)
            // Have to create ol/ul element with li childs so it could display correct order numbers
            // Have to check next comming elements are still in ol/ul tag
            if(tag.name === 'ol' || tag.name === 'ul'){
                const currentListType = tag.name;
                // Do not render if this list item is already rendered in previous element.. i.e..previous element is also list item 
                if(content[i-1] && content[i-1].style === currentListType){
                     // eslint-disable-next-line
                    return;
                }
                //Check next element
                let li = [React.createElement('li', null, createText(content[i].data))];
                let index = i+1;
                while(content[index] && content[index].style === currentListType){
                    li.push(React.createElement('li', null, createText(content[index].data)));
                    index++;
                    contentCount++;
                }
                result.push(React.createElement(currentListType, {key: i}, li));
            } else {
                // Other Tags
                let currentElement = React.createElement(
                    tag.name === 'Heading' ? Heading : tag.name, 
                    tag.level ? { key: i, level: tag.level } : { key: i },
                    createText(paragraph.data)
                );
                result.push(currentElement);
            }

            // Quote
            if(quote){
                if(quotePosition && (quotePosition === contentCount + 1)){
                    result.push(<Quote content={quote} key={i}/>);
                }
                if(!quotePosition && (contentCount === content.length - 1)){
                    result.push(<Quote content={quote} key={i}/>);
                }
            }

            contentCount++;
        });

        return result;
    }

    function createText(data){
        return data.map(item => {
            let element = item.text;
            // Link
            if(item.href){
                element = (React.createElement('a', {href: item.href, target: '_blank'}, element));
            }
            // Styles
            if(item.marks && item.marks.length > 0){
                item.marks.forEach(mark => {
                    if(mark === 'strong' || mark === 'em'){
                        element = (React.createElement(mark, null, element));
                    }
                })
            }
            return element;
        });
    }

    function getReadTime() {
        const urlCountryCode = window.location.hostname.substring(0,2);
        const wordsPerMin = getWordsPerMin(urlCountryCode);
        const time = Math.ceil(wordCount/wordsPerMin);
        return `${time} ${(time > 1) ? 'minutes' : 'minute'}`;
    }

    return (
        <Container>
            <ReadTime> {getReadTime()} {cms.snippets['text-common-read-time'].text}</ReadTime>
            <Content>{renderContent()}</Content>
            <div>
                {tags.map((tag, i) =>
                    <Tag key={i}><Link to={tag.url}>{tag.title}</Link></Tag>
                )}
            </div>
        </Container>
        
     );
}
 
export default Body;
